@if (comments(); as comments) {
  @if (comments.totalComments) {
    <div class="or-bg-white border-radius-4 or-p-12-px card-box-shadow">
      <div (click)="changeVisibility()" class="or-d-flex or-justify-content-between or-align-items-center">
        <div class="or-head-sm">Komplementy ({{ comments.totalComments }})</div>
        <img src="assets/icons/chevron-up.svg" [class.or-rotate-180]="!isExpanded()" />
      </div>
      @if (isExpanded()) {
        <div class="or-mt-12-px">
          @for (
            comment of comments.groupedComments;
            track comment.commentType;
            let i = $index, last = $last, first = $first
          ) {
            <div class="or-d-flex or-align-items-center" [class.or-mb-12-px]="!last || (first && !last)">
              <img
                [src]="'assets/icons/comment-icon.svg'"
                class="or-align-self-start or-d-flex or-mr-8-px or-mt-2-px or-size-20-px" />
              <div>
                <div class="or-text-md or-mb-4-px">
                  {{ commentMapper[comment.commentType].displayName }} ({{
                    comments.groupedComments[i].commentDetails.length
                  }})
                </div>
                @for (
                  commentDetails of comment.commentDetails;
                  track $index;
                  let lastItem = $last, firstItem = $first
                ) {
                  <div class="or-head-xs or-color-secondary-2" [class.or-mb-2-px]="!lastItem || firstItem">
                    {{ commentDetails.authorName }} - {{ commentDetails.createdAt }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
}
